module.exports = __webpack_public_path__ + "img/disgusted.f21e4f85.png";